var exports = {
  "x6": "PlutoniumPageButton.module__button___bnFWal",
  "zB": "PlutoniumPageButton.module__primary___bnFWal",
  "OR": "PlutoniumPageButton.module__danger___bnFWal",
  "EX": "PlutoniumPageButton.module__small___bnFWal",
  "Pf": "PlutoniumPageButton.module__label___bnFWal",
  "Kk": "PlutoniumPageButton.module__icon___bnFWal",
  "u1": "PlutoniumPageButton.module__spinner___bnFWal",
};

module.exports = exports;
